import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value: number, currency = 'CRC'): string {
  if (currency === 'CRC') {
    return new Intl.NumberFormat('es-CR', {
      style: 'currency',
      currency: 'CRC',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  }
  return new Intl.NumberFormat('es-CR', {
    style: 'currency',
    currency,
  }).format(value);
}

export function formatNumber(value: number, decimals = 0): string {
  return new Intl.NumberFormat('es-CR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

export function formatDate(value: string | Date): string {
  if (!value) return '';
  let date: Date;
  if (typeof value === 'string') {
    const [year, month, day] = value.split('-').map(Number);
    if (year && month && day) {
      // Crear fecha con componentes locales para evitar desplazamientos por timezone
      date = new Date(year, month - 1, day);
    } else {
      date = new Date(value);
    }
  } else {
    date = value;
  }
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat('es-CR', {
    year: 'numeric',
    month: 'short',
  }).format(date);
}

export function sanitizeHtml(html: string): string {
  // En producción usar DOMPurify
  const div = document.createElement('div');
  div.textContent = html;
  return div.innerHTML;
}
